import { createContext, useContext } from 'react';

type CMASummaryContent = {
  data: any;
};

export const CMASummaryContext = createContext<CMASummaryContent>({
  data: {},
});

export const useCMASummaryContext = () => useContext(CMASummaryContext);
